// components/participants/AddVirtualParticipantModal.tsx
import { useState } from "react";
import { addVirtualParticipant } from "../../lib/supabaseHelpers";

interface AddVirtualParticipantModalProps {
  tripId: string;
  onClose: () => void;
  onSuccess: () => void;
}

export default function AddVirtualParticipantModal({
  tripId,
  onClose,
  onSuccess,
}: AddVirtualParticipantModalProps) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleAdd = async () => {
    setSaving(true);
    setError("");
    try {
      await addVirtualParticipant(
        tripId,
        firstName,
        lastName,
        email || undefined
      );
      onSuccess();
      onClose();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-[#161b27] rounded-2xl border border-[#2a3347] p-6 w-full max-w-md">
        <h2 className="text-sm font-semibold text-slate-100 mb-5">
          Virtuellen Teilnehmer hinzufügen
        </h2>
        <div className="space-y-3">
          <input
            type="text"
            placeholder="Vorname"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="w-full bg-[#1e2639] border border-[#2a3347] rounded-xl text-slate-100 px-3 py-2 text-sm focus:outline-none focus:border-sky-500/50 placeholder:text-slate-600"
          />
          <input
            type="text"
            placeholder="Nachname"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="w-full bg-[#1e2639] border border-[#2a3347] rounded-xl text-slate-100 px-3 py-2 text-sm focus:outline-none focus:border-sky-500/50 placeholder:text-slate-600"
          />
          <input
            type="email"
            placeholder="E-Mail (optional)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#1e2639] border border-[#2a3347] rounded-xl text-slate-100 px-3 py-2 text-sm focus:outline-none focus:border-sky-500/50 placeholder:text-slate-600"
          />

          {error && <p className="text-xs text-red-400">{error}</p>}

          <div className="flex justify-end gap-2 pt-2">
            <button
              onClick={onClose}
              className="text-xs px-3 py-1.5 rounded-full bg-[#1e2639] text-slate-400 hover:text-slate-200 transition-colors"
            >
              Abbrechen
            </button>
            <button
              onClick={handleAdd}
              disabled={saving}
              className="text-xs px-3 py-1.5 rounded-full bg-sky-600 text-white hover:bg-sky-500 transition-colors disabled:opacity-50"
            >
              {saving ? "Speichern…" : "Hinzufügen"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
